import type { FaqItem } from "@/components/feature/FaqAccordion";

/**
 * Travel-guide FAQs for the Konaseema region page. These power both the
 * on-page FAQ accordion and the matching FAQPage structured data.
 */
export const konaseemaFaqs: FaqItem[] = [
  {
    q: "Where exactly is Konaseema?",
    a: "Konaseema is a green river delta in the East Godavari district of Andhra Pradesh, tucked between the Godavari river and the Bay of Bengal. It lies around 60 km from Rajahmundry and is made up of quiet villages, winding canals and coconut groves.",
  },
  {
    q: "What is the best time to visit Konaseema?",
    a: "October to February offers the most comfortable weather, from 18°C to 30°C, and is ideal for field walks, boating and village tours. Summer brings mango season and beautiful early mornings, while the monsoon turns the delta lush green during paddy planting.",
  },
  {
    q: "How do I reach Konaseema?",
    a: "The nearest airport is Rajahmundry (RJA), about 1.5 to 2 hours by road, and Visakhapatnam (VTZ) is a longer 4 to 5 hour drive. Amalapuram and Rajahmundry are the closest railheads. By road, Konaseema is around 200 km from Vijayawada, with scenic delta roads throughout.",
  },
  {
    q: "What can I do in Konaseema?",
    a: "Popular things to do include backwater boating, coconut grove walks, paddy field trails, temple and heritage visits, tasting authentic Andhra village food and browsing weekly village markets — most of which are woven into our farm and village experiences.",
  },
  {
    q: "Is Konaseema good for families and children?",
    a: "Yes. Families with children love Konaseema's gentle pace — boating, meeting farm animals, fruit picking and village walks are all easy to enjoy together, and the experiences are paced and adjusted for younger visitors.",
  },
  {
    q: "Do I need to book experiences in advance?",
    a: "We recommend booking at least 3 to 5 days ahead so the host families can plan around their farm work. During the cooler October to February window, weekends and holidays fill up the fastest.",
  },
];